var React = require('react');

function IconLabs (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.715 10l-.087-.128V6.634H11.4v3.238l-.088.128h1.402zm1.03 1.5h-3.461l-2.608 3.8c-.123.18-.188.388-.188.6 0 .613.542 1.127 1.232 1.127h6.588c.69 0 1.233-.514 1.233-1.128 0-.211-.065-.419-.189-.599l-2.607-3.8zM9.9 6.5h-.87a.75.75 0 0 1 0-1.5h5.947a.75.75 0 1 1 0 1.5h-.85v2.907l3.46 5.044c.295.43.453.933.453 1.448 0 1.46-1.232 2.628-2.733 2.628H8.72c-1.5 0-2.732-1.167-2.732-2.628 0-.515.157-1.019.451-1.448l3.462-5.044V6.5zM12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm0 1.5a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19zM11 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm2.5 1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z","fill":"currentColor","fillRule":"nonzero"}));
}

IconLabs.defaultProps = {"width":"24","height":"24"};

module.exports = IconLabs;

IconLabs.default = IconLabs;
